module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"text":{"start":"The data in profiles is filled via tasks. Please complete your tasks on Summary page to view","end":"information in the profile."},"button":"Got it"}}')
  delete Component.options._Ctor
}
